// Payment methods list
import {List, Map} from "immutable";

export const paymentTypes = new List([
    new Map({
        type_code: -1,
        type_name: 'Selecciona una forma de pago'
    }),
    new Map({
        type_code: '01',
        type_name: 'Transferencia'
    }),
    new Map({
        type_code: '02',
        type_name: 'Cheque'
    }),
    new Map({
        type_code: '03',
        type_name: 'Pagaré'
    }),
    new Map({
        type_code: '04',
        type_name: 'Contado'
    }),
    new Map({
        type_code: '05',
        type_name: 'Tarjeta'
    }),
    new Map({
        type_code: '06',
        type_name: '30 dias'
    }),
    new Map({
        type_code: '07',
        type_name: '30 y 60 dias'
    }),
    new Map({
        type_code: '08',
        type_name: '30, 60 y 90 dias'
    }),
    new Map({
        type_code: '09',
        type_name: '120 dias'
    })
]);



// WEBPACK FOOTER //
// ./src/components/common/payment-types.js